import React, { useEffect, useState } from 'react';
import SurveyForm from './form';
import {
    BodyProject,
    ProjectsList,
} from '../../../shared/types/project.interface';
import { asyncGetProjects } from '../../../services/project.service';

const SurveyNew = () => {
    const [projects, setProjects] = useState<ProjectsList[]>([]);
    const [onSave, setOnSave] = useState<boolean>(false);
    useEffect(() => {
        asyncGetProjects().then((body: BodyProject) => {
            if (body.items !== undefined) {
                setProjects(
                    body.items.items.map((item) => ({
                        id: item.id,
                        name: item.nameProject,
                    }))
                );
            }
        });
    }, [onSave]);

    return (
        <SurveyForm
            projects={projects}
            onSave={(value: any) => setOnSave(value)}
        />
    );
};

export default SurveyNew;
